import React from 'react';
import PropTypes from 'prop-types';
import {AuthContext} from "../../../providers/AuthProvider";
import {Badge} from "antd";

export default class DashboardPanel extends React.Component {


    //contextType of the component is AuthContext. i.e this.context.auth = TB auth user
    static contextType = AuthContext;
    static header = 'Panel';
    static LastUpdatedMethod = '';

    static is_active = false;
    static inactiveMessage = 'not available yet';
    static inactiveBadgeMessage = 'Coming Soon!';
    static disabledBadgeMessage = 'Not Available Yet!';

    static columns = 'auto'
    static colClass = undefined;
    static columnProps = {
        xl: 4,
        lg: 6,
        md: 6,
        sm: 6,
        xs: 12
    }
    static columnOrdering = {
        xl: undefined,
        lg: undefined,
        md: undefined,
        sm: undefined,
        xs: undefined
    }

    constructor(props, context) {
        super(props, context);

        this.state = {

        }
    }

    isInactive() {
        if (TB.isDefined(this.props.inactive)) {
            return this.props.inactive
        }
        return !this.constructor.is_active
    }

    isDisabled() {
        return this.props.disabled
    }

    disabledReason() {
        return this.props.disabledReason || 'Your profile must be complete and your submission accepted in order to accept projects.';
    }

    hasCompletedProfile() {
        return (this.context.auth?.talent_profile_approved_at && !this.context.auth?.talent_profile_rejected_at) || this.context?.auth?.isProfileApproved()
    }
    didSignAgreement() {
        return this.context?.auth?.didSignAgreement()
    }

    render() {

        let columnProps = {...this.constructor.columnProps};
        if (this.props.columnProps) {
            columnProps = {
                ...columnProps,
                ...this.props.columnProps
            }
        }
        let columnOrdering = {...this.constructor.columnOrdering};
        if (this.props.columnOrdering) {
            columnOrdering = {
                ...columnOrdering,
                ...this.props.columnOrdering
            }
        }

        columnProps = TB.reduce(columnProps, (result, size, key) => {

            let sizeProps = {
                size
            }

            if (columnOrdering[key]) {
                sizeProps.order = columnOrdering[key];
            }
            result[key] = sizeProps;
            return result
        }, {})

        return (
            <div className={[this.constructor.colClass, this.props.colClass].join(' ')}>
                {this.renderPanel()}
            </div>
        );
    }

    renderPanel() {

        if (this.isInactive()) {
            return this.renderInactive()
        }

        if (this.isDisabled()) {
            return this.renderDisabled()
        }


        return (
            <div className={"talent-dashboard-panel " + (this.props.panelClass || '')}>
                {this.renderPanelHeader()}

                {this.renderPanelContent()}
            </div>
        )
    }

    renderPanelContent() {
        return (
            <div/>
        )
    }
    renderDisabled() {
        return (
            <div className={"talent-dashboard-panel disabled " + (this.props.panelClass || '')}>
                {this.renderPanelHeader()}
                <div className="corner">
                    <span>{this.props.disabledBadgeMessage ||  this.constructor.disabledBadgeMessage}</span>
                </div>
                <p className={"message"}>
                    {this.disabledReason()}
                </p>
            </div>
        )
    }

    renderInactive() {
        return (
            <div className={"talent-dashboard-panel inactive " + (this.props.panelClass || '')}>

                <div className="corner">
                    <span>{this.props.inactiveBadgeMessage ||  this.constructor.inactiveBadgeMessage}</span>
                </div>

                <div className="header-content">
                    <h1 className="dashboard-title">
                        {this.props.title || TB.tryTrans(this.constructor.header)}
                    </h1>
                </div>
                <p className="message">
                    {this.props.inactiveMessage || this.constructor.inactiveMessage}
                </p>
            </div>
        )
    }

    renderPanelHeader(title, totalUpdates, daysSinceUpdated)
    {
        if(!title) {
            title = this.props.title || TB.tryTrans(this.constructor.header);
        }
        if(!totalUpdates) {
            totalUpdates = this.props.totalUpdates;
        }
        if (!TB.isDefined(daysSinceUpdated)) {
            daysSinceUpdated = this.daysSinceUpdated()
        }

        return (
            <div className="header-content">
                <Badge count={parseInt(totalUpdates) || 0}>
                    <h1 className="dashboard-title">
                        {title}
                    </h1>
                </Badge>


                {TB.isInteger(daysSinceUpdated) && this.renderLastUpdated(daysSinceUpdated)}
            </div>
        )
    }

    daysSinceUpdated(lastUpdatedMethod = null)
    {
        let method = lastUpdatedMethod || this.constructor.LastUpdatedMethod;
        if (method) {
            return this.context.auth?.[method]?.();
        }
        if (this.props.lastViewed && TB.moment(this.props.lastViewed)) {
            let days = TB.moment(this.props.lastViewed).diff(TB.moment(), 'days');

            if (days < 0) return 0;
        }
        return false
    }

    renderLastUpdated(daysSinceUpdated)
    {
        if (TB.isString(daysSinceUpdated)) {
            daysSinceUpdated = this.daysSinceUpdated(daysSinceUpdated);
        }

        return (
            <div className="header-last-updated">
                <p className={daysSinceUpdated > 30 ? 'text-danger' : ''}>
                    <i className="fas fa-clock"/>
                    &nbsp; {`${daysSinceUpdated} day${(daysSinceUpdated === 1) ? '' : 's'} ago`}
                </p>
            </div>
        )
    }
}

DashboardPanel.defaultProps = {
    disabled: false,
    renderBanner: null
}
DashboardPanel.propTypes = {
    title: PropTypes.string,
    disabled: PropTypes.any,
    col: PropTypes.any,
    renderBanner: PropTypes.any
};